import { LocalDateTime } from '@js-joda/core';

import { convertDateToLocalDateTime } from '@dreryk/react-common';

export const isAppointmentBeganMoreThanDayAgo = (beginDate: Date): boolean => {
   return convertDateToLocalDateTime(beginDate).plusDays(1).isBefore(LocalDateTime.now());
};
